import { render } from "./VisitorDashboard.vue?vue&type=template&id=5ef1cdb4"
import script from "./VisitorDashboard.vue?vue&type=script&lang=js"
export * from "./VisitorDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__